/*
 * Tendy retailer map — goes in the theme as assets/retailer-map.js.
 * Pairs with sections/retailer-map.liquid. Plain browser JS, no build step.
 *
 * What it does: loads the retailer feed, draws Leaflet/OSM pins, lists shops
 * sorted by distance once the visitor searches a place or shares their location,
 * and keeps list ↔ pin selection in sync. Place search suggests as you type via
 * Photon (komoot's OSM geocoder — free and, unlike Nominatim, allowed for
 * autocomplete). Suggestions are biased towards the map's start centre.
 */
;(() => {
  const WORDMARK =
    'M1.22009 25.4401C0.903772 23.8133 0.700427 22.2317 0.610051 20.6953C0.519675 19.1138 0.474487 17.7129 0.474487 16.4929C0.474487 15.2276 0.519675 13.8042 0.610051 12.2226C0.700427 10.641 0.903772 9.03687 1.22009 7.41011H68.324C68.6855 8.5398 68.9567 9.87285 69.1374 11.4092C69.3182 12.9004 69.4085 14.3464 69.4085 15.7473C69.4085 19.2719 68.4822 21.7798 66.6295 23.271C64.822 24.7171 61.9751 25.4401 58.089 25.4401H54.0899C53.0957 25.4401 51.6723 25.4175 49.8196 25.3723C48.0121 25.3271 46.5887 25.3045 45.5494 25.3045H23.7914C22.7973 25.3045 21.3739 25.3271 19.5212 25.3723C17.6685 25.4175 16.245 25.4401 15.2509 25.4401H1.22009ZM23.7914 35.3362C23.7914 33.4835 23.814 31.8341 23.8592 30.3881C23.9044 28.8969 23.927 27.2024 23.927 25.3045V16.3573H45.4138V25.3045C45.4138 27.2024 45.4364 28.8969 45.4816 30.3881C45.5268 31.8341 45.5494 33.4835 45.5494 35.3362V100C43.6967 100.316 41.7988 100.52 39.8557 100.61C37.9126 100.746 36.1955 100.813 34.7043 100.813C33.1679 100.813 31.4282 100.746 29.4851 100.61C27.542 100.52 25.6441 100.316 23.7914 100V35.3362Z M72.9607 73.0229V58.4498H98.5145V56.8908C98.5145 54.8122 98.2207 52.9143 97.6333 51.1971C97.0459 49.4348 96.0969 48.034 94.7865 46.9947C93.5212 45.9102 91.8041 45.3679 89.635 45.3679C86.3363 45.3679 84.0092 46.7235 82.6535 49.4348C81.3431 52.1461 80.6879 56.3259 80.6879 61.9744V68.3459C80.6879 71.4187 80.959 74.2881 81.5012 76.9542C82.0435 79.6203 83.1958 81.7667 84.9581 83.3935C86.7204 85.0202 89.4091 85.8336 93.0241 85.8336C96.0969 85.8336 99.1019 85.4495 102.039 84.6813C105.022 83.8679 107.868 82.8964 110.58 81.7667C112.161 83.3031 113.426 85.2462 114.375 87.5959C115.324 89.9457 115.957 92.1825 116.273 94.3063C112.839 96.7917 108.727 98.6895 103.937 100C99.1923 101.356 94.4024 102.033 89.5673 102.033C83.6025 102.033 78.677 101.062 74.7908 99.1188C70.9047 97.1306 67.8319 94.4645 65.5725 91.1206C63.3131 87.7315 61.709 83.9357 60.76 79.7332C59.8563 75.4856 59.4044 71.125 59.4044 66.6514C59.4044 59.828 60.4211 53.6825 62.4546 48.2147C64.5332 42.7018 67.8093 38.3412 72.2829 35.1329C76.7565 31.9245 82.5857 30.3203 89.7706 30.3203C95.7354 30.3203 100.819 31.5856 105.022 34.1161C109.224 36.6466 112.432 40.0809 114.647 44.419C116.906 48.7118 118.036 53.5921 118.036 59.0598C118.036 62.0874 117.877 64.6179 117.561 66.6514C117.29 68.6396 116.838 70.7635 116.205 73.0229H72.9607Z M137.485 31.4049C141.552 31.4049 144.602 32.8057 146.635 35.6073C148.714 38.3638 149.753 42.0918 149.753 46.7913V100C148.262 100.271 146.567 100.474 144.67 100.61C142.817 100.746 140.987 100.813 139.179 100.813C137.417 100.813 135.587 100.746 133.689 100.61C131.836 100.474 130.119 100.271 128.538 100V32.3538L129.486 31.4049H137.485ZM186.83 83.0546C186.83 85.6755 187.078 88.1608 187.575 90.5106C188.073 92.8151 188.954 94.826 190.219 96.5431C188.683 97.8084 186.762 98.8929 184.457 99.7967C182.153 100.655 179.668 101.085 177.001 101.085C172.754 101.085 169.794 99.9548 168.122 97.6954C166.45 95.436 165.614 92.1825 165.614 87.9348V59.1276C165.614 56.0548 165.207 53.7954 164.394 52.3494C163.626 50.8582 162.112 50.1126 159.853 50.1126C158.452 50.1126 156.825 50.4967 154.972 51.2649C153.165 51.9879 151.335 53.208 149.482 54.9251C147.675 56.6423 146.07 58.9242 144.67 61.7711V43.1989C147.878 40.1261 151.335 37.3471 155.04 34.8617C158.791 32.3764 163.061 31.1337 167.851 31.1337C172.008 31.1337 175.488 32.173 178.289 34.2517C181.091 36.2851 183.215 39.1094 184.661 42.7244C186.107 46.3394 186.83 50.5193 186.83 55.264V83.0546Z M257.153 80.4111C257.153 82.5801 257.492 84.5458 258.17 86.3081C258.893 88.0704 259.819 89.3809 260.949 90.2394C260.543 92.0921 259.684 94.103 258.374 96.272C257.108 98.441 255.82 100.045 254.51 101.085C248.545 100.994 244.049 98.9833 241.021 95.0519C237.994 91.1206 236.48 86.3307 236.48 80.6822V1.17419L237.429 0.225239H245.698C249.856 0.225239 252.793 1.17418 254.51 3.07208C256.272 4.96997 257.153 8.26868 257.153 12.9682V80.4111ZM196.828 66.9903C196.828 59.218 198.048 52.6657 200.488 47.3336C202.973 41.9562 206.272 37.8893 210.384 35.1329C214.496 32.3764 219.037 30.9982 224.008 30.9982C228.708 30.9982 232.865 31.9697 236.48 33.9128C240.14 35.8107 243.462 37.686 246.444 39.5387L243.055 54.5862C240.434 52.4624 237.768 50.6323 235.057 49.0959C232.345 47.5143 229.883 46.7235 227.668 46.7235C225.499 46.7235 223.737 47.5595 222.381 49.2315C221.071 50.8582 220.099 53.208 219.467 56.2808C218.834 59.3083 218.518 62.9234 218.518 67.1258C218.518 71.2831 218.857 74.6948 219.535 77.3609C220.258 79.9818 221.229 81.9249 222.449 83.1901C223.714 84.4102 225.115 85.0202 226.652 85.0202C228.098 85.0202 229.77 84.5909 231.667 83.7324C233.611 82.8286 235.486 81.1567 237.293 78.7165C239.146 76.2312 240.66 72.6162 241.835 67.8714L246.579 79.8688C246.173 83.529 244.795 87.0537 242.445 90.4428C240.095 93.8319 237.067 96.6109 233.362 98.7799C229.702 100.949 225.635 102.033 221.161 102.033C215.694 102.033 211.152 100.542 207.537 97.5599C203.922 94.5775 201.233 90.4428 199.471 85.1558C197.709 79.8688 196.828 73.8136 196.828 66.9903Z M313.271 98.1699C311.645 104.315 309.589 109.761 307.103 114.505C304.618 119.25 301.229 122.955 296.936 125.622C292.688 128.333 287.04 129.688 279.991 129.688C277.279 129.688 274.32 129.372 271.111 128.739C267.903 128.152 265.372 127.542 263.52 126.909C263.294 124.514 263.587 121.803 264.401 118.776C265.259 115.748 266.389 113.421 267.79 111.794C269.236 112.246 271.066 112.698 273.28 113.15C275.54 113.647 277.776 113.895 279.991 113.895C282.295 113.895 284.306 113.443 286.023 112.54C287.785 111.681 289.254 110.416 290.429 108.744C291.649 107.117 292.598 105.174 293.276 102.915L293.818 100.949C290.158 100.904 287.108 100.271 284.668 99.0511C282.273 97.7858 280.623 95.5716 279.719 92.4084L263.926 33.9806C266.095 32.9864 268.377 32.2634 270.772 31.8115C273.167 31.3597 275.246 31.1337 277.008 31.1337C279.584 31.1337 281.708 31.7664 283.38 33.0316C285.097 34.2969 286.385 36.6918 287.243 40.2165L293.615 66.3125C294.021 67.8037 294.405 69.679 294.767 71.9384C295.129 74.1526 295.467 76.3668 295.784 78.581C296.145 80.75 296.416 82.5801 296.597 84.0713C296.687 84.7039 297.072 85.0202 297.749 85.0202L309.543 32.4216C310.718 32.1053 312.074 31.8793 313.61 31.7438C315.147 31.6082 316.57 31.5404 317.881 31.5404C319.733 31.5404 321.609 31.6534 323.506 31.8793C325.404 32.0601 327.302 32.4668 329.2 33.0994L330.014 34.5228L313.271 98.1699Z'

  // Same label pin as the CRM map: 96×46 design space, wordmark inside, tail at bottom-centre.
  const pinSvg = (width, fill, glyph, stroke) => {
    const h = Math.round((width * 46) / 96)
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${h}" viewBox="0 0 96 46"><path d="M12 3 H84 A9 9 0 0 1 93 12 V28 A9 9 0 0 1 84 37 H54 L48 44 L42 37 H12 A9 9 0 0 1 3 28 V12 A9 9 0 0 1 12 3 Z" fill="${fill}" stroke="${stroke}" stroke-width="1.5" stroke-linejoin="round"/><g transform="translate(15 8.7) scale(0.2)"><path d="${WORDMARK}" fill="${glyph}"/></g></svg>`
  }

  const haversineKm = (a, b) => {
    const R = 6371
    const dLat = ((b.lat - a.lat) * Math.PI) / 180
    const dLng = ((b.lng - a.lng) * Math.PI) / 180
    const la1 = (a.lat * Math.PI) / 180
    const la2 = (b.lat * Math.PI) / 180
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) ** 2
    return 2 * R * Math.asin(Math.sqrt(h))
  }

  const fmtKm = (km) => (km < 10 ? km.toFixed(1) : Math.round(km)).toString().replace('.', ',') + ' km'
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c])
  const href = (url) => (/^https?:\/\//i.test(url) ? url : `https://${url}`)
  const directions = (r) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${r.address}, ${r.zipCode} ${r.city}, ${r.country}`)}`

  function whenLeaflet(cb) {
    if (window.L) return cb(window.L)
    const tick = () => (window.L ? cb(window.L) : setTimeout(tick, 50))
    tick()
  }

  function init(root) {
    const t = (k) => root.dataset[`i18n${k}`] || ''
    const feed = root.dataset.feed
    const mapEl = root.querySelector('.trm__map')
    const listEl = root.querySelector('.trm__list')
    const statusEl = root.querySelector('.trm__status')
    const searchEl = root.querySelector('.trm__search-input')
    const filterEl = root.querySelector('.trm__filter')
    const locateBtn = root.querySelector('.trm__locate')
    const clearBtn = root.querySelector('.trm__clear')
    const accent = getComputedStyle(root).getPropertyValue('--trm-accent').trim() || '#053621'

    if (!feed) {
      listEl.innerHTML = `<li class="trm__empty">Feed URL is not set (section settings).</li>`
      return
    }

    // Zoomed out, 90+ labels pile up — use a small disc until the map is at county level.
    const ICON = {
      default: { html: pinSvg(72, '#ffffff', accent, accent), size: [72, 35] },
      active: { html: pinSvg(96, accent, '#ffffff', '#ffffff'), size: [96, 46] },
      disc: {
        html: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><circle cx="7" cy="7" r="5.5" fill="#ffffff" stroke="${accent}" stroke-width="2"/></svg>`,
        size: [14, 14],
      },
    }
    const LABEL_ZOOM = 9

    let L
    let map
    let retailers = []
    let markers = new Map()
    let origin = null // {lat,lng} the visitor searched / shared
    let originMarker = null
    let activeId = null
    let filter = ''

    const icon = (kind) => {
      const { html, size } = ICON[kind]
      const centred = kind === 'disc'
      return L.divIcon({
        className: 'trm__pin',
        html,
        iconSize: size,
        iconAnchor: centred ? [size[0] / 2, size[1] / 2] : [size[0] / 2, size[1]],
        popupAnchor: [0, centred ? -size[1] / 2 : -size[1] + 6],
      })
    }
    const restingIcon = () => icon(map && map.getZoom() >= LABEL_ZOOM ? 'default' : 'disc')

    function popupHtml(r) {
      const links = []
      if (r.website) links.push(`<a href="${esc(href(r.website))}" target="_blank" rel="noopener">${esc(t('Website'))}</a>`)
      links.push(`<a href="${esc(directions(r))}" target="_blank" rel="noopener">${esc(t('Directions'))}</a>`)
      return `<b>${esc(r.name)}</b>${esc(r.address)}<br>${esc(r.zipCode)} ${esc(r.city)}<br><span style="display:flex;gap:.8rem;margin-top:.4rem">${links.join('')}</span>`
    }

    function visible() {
      const q = filter.trim().toLowerCase()
      let list = q
        ? retailers.filter((r) => `${r.name} ${r.address} ${r.city} ${r.zipCode}`.toLowerCase().includes(q))
        : retailers.slice()
      if (origin) {
        list = list.map((r) => ({ ...r, km: haversineKm(origin, r) })).sort((a, b) => a.km - b.km)
      }
      return list
    }

    function setActive(id, { pan = true } = {}) {
      if (activeId && markers.get(activeId)) markers.get(activeId).setIcon(restingIcon()).setZIndexOffset(0)
      activeId = id
      const m = id && markers.get(id)
      if (m) {
        m.setIcon(icon('active')).setZIndexOffset(1000)
        if (pan) {
          map.flyTo(m.getLatLng(), Math.max(map.getZoom(), 11), { duration: 0.6 })
          m.openPopup()
        }
      }
      for (const li of listEl.children) li.classList.toggle('trm__item--active', li.dataset.id === id)
      const li = listEl.querySelector(`[data-id="${CSS.escape(id || '')}"]`)
      if (li) li.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
    }

    function renderList() {
      const list = visible()
      if (list.length === 0) {
        listEl.innerHTML = `<li class="trm__empty">${esc(t('Empty'))}</li>`
        return
      }
      listEl.innerHTML = list
        .map(
          (r) => `<li class="trm__item${r.id === activeId ? ' trm__item--active' : ''}" data-id="${esc(r.id)}">
  <button type="button" class="trm__item-btn">
    <span style="display:flex;justify-content:space-between;gap:.5rem;align-items:baseline">
      <span class="trm__item-name">${esc(r.name)}</span>
      ${r.km != null ? `<span class="trm__item-dist">${fmtKm(r.km)}</span>` : ''}
    </span>
    <span class="trm__item-addr">${esc(r.address)}<br>${esc(r.zipCode)} ${esc(r.city)}${r.country && r.country !== 'Sweden' && r.country !== 'Sverige' ? `, ${esc(r.country)}` : ''}</span>
    <span class="trm__item-links">
      ${r.website ? `<a href="${esc(href(r.website))}" target="_blank" rel="noopener">${esc(t('Website'))}</a>` : ''}
      <a href="${esc(directions(r))}" target="_blank" rel="noopener">${esc(t('Directions'))}</a>
    </span>
  </button>
</li>`,
        )
        .join('')
      // Pin visibility follows the filter.
      const ids = new Set(list.map((r) => r.id))
      for (const [id, m] of markers) {
        if (ids.has(id)) m.addTo(map)
        else m.remove()
      }
    }

    function setOrigin(point, label) {
      origin = point
      if (originMarker) originMarker.remove()
      originMarker = L.circleMarker(point, { radius: 7, color: '#fff', weight: 2, fillColor: '#c2410c', fillOpacity: 1 }).addTo(map)
      if (label) originMarker.bindTooltip(label, { direction: 'top', offset: [0, -8] })
      statusEl.textContent = ''
      renderList()
      // Frame the origin together with its nearest handful of shops.
      const nearest = visible().slice(0, 5)
      const bounds = L.latLngBounds([point, ...nearest.map((r) => [r.lat, r.lng])])
      map.flyToBounds(bounds, { padding: [40, 40], maxZoom: 11, duration: 0.8 })
    }

    // --- wiring: list + filter ---
    listEl.addEventListener('click', (e) => {
      const li = e.target.closest('.trm__item')
      if (!li || e.target.closest('a')) return
      setActive(li.dataset.id)
    })

    filterEl.addEventListener('input', () => {
      filter = filterEl.value
      renderList()
    })

    // --- place search (Photon, autocomplete-friendly) ---
    const suggestEl = root.querySelector('.trm__suggest')
    let suggestions = []
    let highlighted = -1
    let searchTimer = null
    let searchSeq = 0

    async function geocode(query) {
      // Photon localises only en/de/fr and 400s on anything else; "default"
      // returns the local name (Göteborg, not Gothenburg), which is what a
      // Swedish shop wants for every other language.
      const lang = (document.documentElement.lang || '').slice(0, 2)
      const langParam = `&lang=${['en', 'de', 'fr'].includes(lang) ? lang : 'default'}`
      // No lat/lon bias: Photon weights proximity so hard that a map centred on
      // Hälsingland turned "stock" into a hamlet near Ljusdal. A bounding box
      // limits the area without favouring its middle.
      const bbox = root.dataset.bbox ? `&bbox=${encodeURIComponent(root.dataset.bbox)}` : ''
      const base = `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}${langParam}${bbox}`
      const PLACE_TAGS = ['place:city', 'place:town', 'place:village', 'place:municipality']
        .map((t) => `&osm_tag=${t}`)
        .join('')
      // Two requests: populated places (what people mostly type) and everything
      // else (postcodes, street addresses). Places rank first in the merge.
      const [places, general] = await Promise.all([
        fetch(`${base}&limit=5${PLACE_TAGS}`).then((r) => (r.ok ? r.json() : { features: [] })),
        fetch(`${base}&limit=6`).then((r) => (r.ok ? r.json() : { features: [] })),
      ])
      const bias = (root.dataset.countryBias || '').toUpperCase().split(',').map((c) => c.trim()).filter(Boolean)
      const TIER = { city: 0, town: 0, municipality: 1, village: 1, suburb: 2, hamlet: 2, postcode: 3, house: 4, street: 4 }
      const toHit = (f, i, offset) => {
        const p = f.properties || {}
        const [lng, lat] = f.geometry.coordinates
        const tier = TIER[p.osm_value] ?? TIER[p.type]
        if (tier === undefined) return null // administrative areas, rivers, stadiums, tracks…
        const isAddress = p.type === 'house' || p.type === 'street'
        const name = isAddress ? [p.street || p.name, p.housenumber].filter(Boolean).join(' ') : p.name || ''
        const detail = [
          p.postcode,
          p.city && p.city !== name ? p.city : null,
          p.county && p.county !== name ? p.county : p.state && p.state !== name ? p.state : null,
          p.country,
        ]
          .filter(Boolean)
          .join(', ')
        return { lat, lng, name, detail, cc: p.countrycode, tier, i: offset + i }
      }
      const seen = new Set()
      return [
        ...(places.features || []).map((f, i) => toHit(f, i, 0)),
        ...(general.features || []).map((f, i) => toHit(f, i, 100)),
      ]
        .filter((h) => h && h.name && (bias.length === 0 || bias.includes((h.cc || '').toUpperCase())))
        .filter((h) => {
          const key = `${h.name}|${h.detail}`.toLowerCase()
          if (seen.has(key)) return false
          seen.add(key)
          return true
        })
        .sort((a, b) => a.tier - b.tier || a.i - b.i)
        .slice(0, 6)
    }

    function hideSuggestions() {
      suggestEl.hidden = true
      suggestEl.innerHTML = ''
      suggestions = []
      highlighted = -1
    }

    function showSuggestions(list) {
      suggestions = list
      highlighted = -1
      if (list.length === 0) {
        hideSuggestions()
        return
      }
      suggestEl.innerHTML = list
        .map((h, i) => `<li role="option" data-i="${i}"><b>${esc(h.name)}</b>${h.detail ? `<small>${esc(h.detail)}</small>` : ''}</li>`)
        .join('')
      suggestEl.hidden = false
    }

    function choose(hit) {
      hideSuggestions()
      searchEl.value = hit.detail ? `${hit.name}, ${hit.detail.split(',')[0]}` : hit.name
      clearBtn.hidden = false
      setOrigin({ lat: hit.lat, lng: hit.lng }, hit.name)
    }

    function highlight(i) {
      highlighted = i
      for (const li of suggestEl.children) li.setAttribute('aria-selected', String(Number(li.dataset.i) === i))
    }

    searchEl.addEventListener('input', () => {
      const q = searchEl.value.trim()
      clearBtn.hidden = q === ''
      clearTimeout(searchTimer)
      if (q.length < 2) {
        hideSuggestions()
        return
      }
      const seq = ++searchSeq
      searchTimer = setTimeout(async () => {
        try {
          const hits = await geocode(q)
          if (seq === searchSeq) showSuggestions(hits)
        } catch {
          if (seq === searchSeq) hideSuggestions()
        }
      }, 250)
    })

    searchEl.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' && suggestions.length) {
        e.preventDefault()
        highlight(Math.min(highlighted + 1, suggestions.length - 1))
      } else if (e.key === 'ArrowUp' && suggestions.length) {
        e.preventDefault()
        highlight(Math.max(highlighted - 1, 0))
      } else if (e.key === 'Enter') {
        e.preventDefault()
        if (suggestions.length) choose(suggestions[highlighted >= 0 ? highlighted : 0])
      } else if (e.key === 'Escape') {
        hideSuggestions()
      }
    })

    suggestEl.addEventListener('mousedown', (e) => {
      const li = e.target.closest('li')
      if (li) {
        e.preventDefault() // keep focus; blur would hide the list first
        choose(suggestions[Number(li.dataset.i)])
      }
    })
    searchEl.addEventListener('blur', () => setTimeout(hideSuggestions, 150))

    function clearOrigin() {
      origin = null
      if (originMarker) originMarker.remove()
      originMarker = null
      searchEl.value = ''
      clearBtn.hidden = true
      hideSuggestions()
      statusEl.textContent = ''
      renderList()
      if (retailers.length) map.fitBounds(L.latLngBounds(retailers.map((r) => [r.lat, r.lng])), { padding: [30, 30] })
    }
    clearBtn.addEventListener('click', () => {
      clearOrigin()
      searchEl.focus()
    })

    locateBtn.addEventListener('click', () => {
      if (!navigator.geolocation) return
      locateBtn.setAttribute('aria-busy', 'true')
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          locateBtn.removeAttribute('aria-busy')
          searchEl.value = t('Locate')
          clearBtn.hidden = false
          setOrigin({ lat: pos.coords.latitude, lng: pos.coords.longitude }, t('Locate'))
        },
        () => {
          // Denied or unavailable — nothing to say beyond un-busying the button.
          locateBtn.removeAttribute('aria-busy')
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 },
      )
    })

    whenLeaflet(async (leaflet) => {
      L = leaflet
      map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true }).setView(
        [Number(root.dataset.lat), Number(root.dataset.lng)],
        Number(root.dataset.zoom),
      )
      // OSM's own tiles: keyless. CARTO basemaps started requiring an API key (Sep 2026).
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(map)

      try {
        const res = await fetch(feed, { headers: { Accept: 'application/json' } })
        if (!res.ok) throw new Error(`feed ${res.status}`)
        const data = await res.json()
        retailers = (data.retailers || []).filter((r) => Number.isFinite(r.lat) && Number.isFinite(r.lng))
      } catch (err) {
        console.error('[retailer-map]', err)
        listEl.innerHTML = `<li class="trm__empty">${esc(t('Error'))}</li>`
        return
      }

      for (const r of retailers) {
        const m = L.marker([r.lat, r.lng], { icon: icon('disc'), title: r.name }).bindPopup(popupHtml(r))
        m.on('click', () => setActive(r.id, { pan: false }))
        m.on('popupclose', () => {
          if (activeId === r.id) setActive(null)
        })
        markers.set(r.id, m)
      }
      map.on('zoomend', () => {
        const resting = restingIcon()
        for (const [id, m] of markers) if (id !== activeId) m.setIcon(resting)
      })
      renderList()
      if (retailers.length) map.fitBounds(L.latLngBounds(retailers.map((r) => [r.lat, r.lng])), { padding: [30, 30] })
    })
  }

  const boot = () => document.querySelectorAll('[data-tendy-retailers]:not([data-ready])').forEach((el) => {
    el.dataset.ready = '1'
    init(el)
  })
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot)
  else boot()
  // Theme editor re-renders sections on setting changes.
  document.addEventListener('shopify:section:load', boot)
})()
